import {
  TEditDeviceGroupFields,
  TEditDeviceGroupLocationFields,
} from 'shared/types'
import { api } from '..'

export const editDeviceGroupInfo =
  (deviceGroupId: string) => (data: TEditDeviceGroupFields) =>
    api.put(`/v1/device-group/${deviceGroupId}/information`, data)

export const editDeviceGroupLocation =
  (deviceGroupId: string) => (data: TEditDeviceGroupLocationFields) =>
    api.put(`/v1/device-group/${deviceGroupId}/location`, data)

export const editDeviceGroup =
  (deviceGroupId: string) =>
  ({
    locationId,
    ...data
  }: TEditDeviceGroupFields & TEditDeviceGroupLocationFields) =>
    Promise.all([
      api.put(`/v1/device-group/${deviceGroupId}/information`, data),
      api.put(`/v1/device-group/${deviceGroupId}/location`, { locationId }),
    ])
